<template>
  <div>
    <!-- 自定义导航栏 -->
    <!-- <u-navbar back-text="即插即充设置"></u-navbar> -->
    <div class="content">
      <div class="top-title">
        隐私权政策摘要
      </div>
      <div class="contents">
        <text style="font-weight: 800;">我们</text
        >（具体包括：上海挚达科技发展股份有限公司、无锡挚达物联科技有限公司、上海挚达新能源汽车公共配套发展有限公司）<text
          style="font-weight: 800;"
          >通过挚达App、挚达支付宝小程序、桩到家App、桩到家微信小程序、桩到家支付宝小程序以及实现全部或部分服务功能的其他平台，包括但不限于网站、App、小程序、微信公众号（以下简称“平台”）提供“新能源汽车充电服务”。</text
        >
      </div>
      <div class="contents">
        我们高度重视您的个人信息安全，我们将严格遵守法律法规，为你提供更加安全、可靠的服务。以下摘要能帮助你更直观、简洁地概览平台隐私权政策的内容。
      </div>
      <div class="contents">
        请您注意，阅读本摘要并不代表已阅读隐私权政策全文，如您希望了解我们详细的隐私政策，请查阅完整的《隐私权政策》。
      </div>
      <div class="title-medim">
        一、我们如何收集和使用您的个人信息
      </div>
      <div class="title-medim">
        （一）基于基本业务功能我们收集您的用户信息的情形
      </div>
      <div class="title-medim">
        1.帮助您成为我们的用户
      </div>
      <div class="contents">
        当您注册时，您需要至少向我们提供您准备使用的<text
          style="font-weight: 800;"
          >注册手机号</text
        >、验证码。您也可以通过使用微信等第三方平台的账号注册我们的账户，届时我们将收集您的第三方平台昵称、账号、Open
        ID，为您生成账号，您也可以选择届时将您的手机号与您的账号绑定。
      </div>
      <div class="title-medim">
        2.帮助您绑定充电桩
      </div>
      <div class="contents">
        当您绑定充电桩时，您需要向我们提供您的<text style="font-weight: 800;"
          >摄像头(相机)权限、相册权限</text
        >，用于扫描或上传充电桩IMEI码。
      </div>
      <div class="title-medim">
        3.帮助您完成订单支付
      </div>
      <div class="contents">
        您在平台完成充电订单并支付后，我们将收集您的<text
          style="font-weight: 800;"
          >支付时间、支付金额、支付渠道、支付流水号等支付信息</text
        >，用于确认订单支付状态。
      </div>
      <div class="title-medim">
        （二）基于扩展业务功能我们收集您的用户信息的情形
      </div>
      <div class="title-medim">
        1.附近充电桩
      </div>
      <div class="contents">
        为了便捷您发现周边的充电站/充电桩，我们会基于您的地理位置为您提供服务（LBS）。我们会使用有关技术对您的实际位置进行定位，这些技术<text
          style="font-weight: 800;"
          >包括IP地址、GPS以及能够提供相关信息的Wi-Fi
          接入点、蓝牙和基站等传感器技术。</text
        >
      </div>
      <div class="title-medim">
        2.使用蓝牙模式（仅App平台及挚达支付宝小程序支持）
      </div>
      <div class="contents">
        当您选择使用蓝牙模式时，您需要向我们提供您的<text
          style="font-weight: 800;"
          >蓝牙权限</text
        >，用于连接充电桩，以便您使用“蓝牙无感”充电功能。
      </div>
      <div class="title-medim">3.共享充电桩（仅挚达支付宝小程序支持）</div>
      <div class="contents">
        当您选择向平台内充电桩桩主申请共享使用授权时，我们需要您提供您的平台账号、手机号码、车辆型号，用于审核您的申请，以便您能够使用共享充电桩充电功能。同时，<text
          style="font-weight: 800;"
          >为确保充电桩桩主与您取得联系，我们需要将您的平台账号、手机号码提供给充电桩桩主。</text
        >
      </div>
      <div class="title-medim">4.绑定您的车辆</div>
      <div class="contents">
        当您选择在平台绑定您的新能源汽车时，您需要向我们提供您的<text
          style="font-weight: 800;"
          >车辆型号、车牌号</text
        >，以完成车辆绑定。
      </div>
      <div class="title-medim">5.个人信息维护</div>
      <div class="contents">
        如您点击更换头像，您需要向我们提供您的<text style="font-weight: 800;"
          >摄像头(相机)权限、相册权限</text
        >，用于拍摄照片或上传照片；同时，您可以选择向我们提供您的出生年月日、性别、地区信息。
      </div>
      <div class="title-medim">
        6.客户服务
      </div>
      <div class="contents">
        当您与我们的客服取得联系时，我们的系统可能会记录您与客服之间的通讯记录，使用您的账号信息核验身份；当提供与您订单相关的客户服务时，我们可能会查询您的相关订单信息。
      </div>
      <div class="title-medim">
        7.安全保障功能
      </div>
      <div class="contents">
        当您使用我们提供的产品/服务时，我们会自动收集您使用我们服务的详细情况，并作为有关的网络日志保存。
      </div>
      <div class="title-medim">
        二、我们如何共享、转让、公开披露您的个人信息
      </div>
      <div class="title-medim">
        （一）信息的共享
      </div>
      <div class="contents">
        我们对您的个人信息承担保密义务，但您授权我们将您的信息与第三方共享。
      </div>
      <div class="contents">
        为使您能够使用和享受相应的服务及功能，我们会在平台中嵌入第三方的SDK，我们审慎评估该等SDK的使用目的。有关SDK处理个人信息的目的、方式及范围等信息，请查看《个人信息共享清单》。
      </div>
      <div class="title-medim">
        （二）共同处理
      </div>
      <div class="contents">
        平台由多个主体共同为您提供服务，<text style="font-weight: 800;"
          >为便于我们向您提供一致化服务、实现安全风控、提供客户服务、实现产品功能之需要，您可使用同一账号登录和使用不同平台，使用同一账号登录的平台将同步您注册登录、使用我们服务的个人信息，包括您的基本资料信息，包括昵称、头像以及本政策披露的其他个人信息。</text
        >
      </div>
      <div class="title-medim">
        （三）信息的转让
      </div>
      <div class="contents">
        我们不会将您的个人信息转让给除关联公司外的任何公司、组织和个人，除非事先获得您的明确授权或同意，或根据法律法规、您签署的其它法律文件，或涉及合并、收购或破产清算时转让。
      </div>
      <div class="title-medim">
        （四）信息的公开披露
      </div>
      <div class="contents">
        我们仅会在获得您明确同意或基于您的主动选择、为保护我们及关联公司用户或公众的人身财产安全免遭侵害的情况下，公开披露您的个人信息。
      </div>
      <div class="title-medim">
        四、我们如何存储和保护您的个人信息
      </div>
      <div class="contents">
        我们依照法律法规的规定，将您的个人信息存储于中华人民共和国境内。我们在为提供我们的产品和服务之目的所必需且最短的期间内保留您的个人信息。
      </div>
      <div class="contents">
        当平台决定停止运营时，我们将在平台停止运营后停止继续收集您的个人信息。
        我们将采用严格的安全制度以及行业通行的安全技术和程序来确保您的个人信息不被丢失、泄露、损毁或滥用。
      </div>
      <div class="title-medim">
        五、您的权利
      </div>
      <div class="contents">
        按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使访问、更正、删除您的个人信息、改变您授权同意的范围、注销账号、获取个人信息副本、转移个人信息的权利，对于您的请求，我们将在15个工作日内核查和处理。
        如果您认为您的个人信息权利可能受到侵害，或者发现侵害个人信息权利的线索，您可通过以下联系方式与我们联系。
      </div>
      <div class="title-medim">
        六、我们如何处理限制民事行为能力人的个人信息
      </div>
      <div class="contents">
        我们通过平台提供的服务不面向限制民事行为能力人，如您是限制民事行为能力人，请立即停止使用平台服务。如果我们发现自己在未事先获得可证实的监护人同意的情况下收集了限制民事行为能力人的个人信息，则会设法尽快删除相关数据。
      </div>
      <div class="title-medim">
        八、如何联系我们
      </div>
      <div class="contents">
        您可随时通过以下方式与我们联系
      </div>
      <div class="contents">
        固定电话：4006596580
      </div>
      <div class="contents">
        邮箱：service@shzhida.com
      </div>
      <div class="contents">
        我们会在15个工作日内积极进行查证、处理并尽快答复。
      </div>
    </div>
  </div>
</template>

<script>
// import tabbar from '../../component/tabbar.vue'
export default {
  // components:{
  // 	tabbar
  // },
  data() {
    return {
      checked: null,
    };
  },
  onLoad() {},
  onReady() {},
  onShow() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.content {
  box-sizing: border-box;
  padding: 16px;
  background-color: #fff;
  display: flex;
  height: 100%;
  flex-direction: column;

  .top-title {
    text-align: center;
    margin-top: 15px;
    font-size: 14px;
    font-weight: 800;
    margin-bottom: 10px;
  }

  .title-medim {
    margin-top: 15px;
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 5px;
  }

  .contents {
    // text-indent: 2em;
    font-size: 12px;
    line-height: 18px;
  }

  .box {
    display: flex;
    width: 100%;
    text-indent: 0;
    border: 1px solid #000000;

    > div {
      display: flex;
      flex-direction: column;
      text-align: center;
    }

    .box-item {
      border-right: 1px solid #000000;
      flex: 1;

      > div {
        &:nth-child(1) {
          border-bottom: 1px solid #000000;
          height: 40px;
        }
      }
    }
  }
}
</style>
